import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';

const modalStyles = css`
  position: absolute;
  top: 30px;
  width: calc(100vw - 60px);
  left: 30px;
  height: calc(100vh - 60px);
  z-index: 0;
  @media (max-width: 991px) {
    top: 15px;
    left: 15px;
    right: 15px;
    width: auto;
    margin: 0;
  }

  iframe {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  a.modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    font-size: 30px;
    line-height: 30px;
    color: #FFFFFF;
    @media (min-width: 992px) {
      top: -30px;
      right: -15px;
    }
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.7);
  overflow-y: auto;

  .RenderingHouseModal_mobileIcons {
    height: 54px;
    width: 30%;
    max-width: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 15px;
  }

  .RenderingHouseModal_or {
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
  }
`;

class RenderingHouseModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, plan } = this.props;
    return (
      <div>
        <span role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <a href className="modal-close" onClick={this.closeModal}>&times;</a>
          <iframe title="Home Designer" src={get(plan, 'rendering_house_link')} frameBorder="0" />
        </Modal>
      </div>
    );
  }
}

RenderingHouseModal.propTypes = {
  plan: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default RenderingHouseModal;



// WEBPACK FOOTER //
// ./src/components/RenderingHouseModal.js